import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterBy' })
export class FilterByPipe implements PipeTransform {
  transform(values: any[], key: string | null, filter: any): any[] {
    if (!values?.length || filter === undefined || filter === null) return values;

    if (key) return values.filter(item => this.matchesKey(item, key, filter));

    return values.filter(item => this.matchesAnyKey(item, filter));
  }

  private matchesKey(item: any, key: string, filter: any): boolean {
    const itemValue = this.getNestedValue(item, key);
    if (itemValue === undefined || itemValue === null) return false;

    const filterStr = String(filter).toLowerCase();

    if (typeof itemValue === 'string') {
      const itemStr = itemValue.toLowerCase();
      if (filterStr === '!null') return itemStr.length > 0;
      if (key.includes('.') && itemStr.includes(filterStr)) return true;
      return itemStr === filterStr;
    }

    return itemValue === filter;
  }

  private matchesAnyKey(item: any, filter: any): boolean {
    const filterStr = String(filter).toLowerCase();
    return Object.values(item).some((val:any) => val?.toString().toLowerCase().includes(filterStr));
  }

  private getNestedValue(obj: any, keyString: string): any {
    return keyString.split('.').reduce((acc, k) => acc[k], obj);
  }
}



@Pipe({ name: 'filterQ' })
export class FilterQ implements PipeTransform {
  transform(items: any[], filter: Record<string, any>, isAnd: boolean): any[] {
    if (!items || !filter) return items;
    const keys = Object.keys(filter).filter(k => filter[k] !== undefined && filter[k] !== null && !(typeof filter[k] === 'string' && filter[k].trim() === ''));
    if (!keys.length) return items;
    return items.filter(item => this.checkAllKeys(item, keys, filter, isAnd));
  }

  private checkAllKeys(item: any, keys: string[], filter: Record<string, any>, isAnd: boolean): boolean {
    const results = keys.map(key => {
      const raw = filter[key];
      const isExclude = typeof raw === 'string' && raw.startsWith('!');
      let filterValue: any;
      if (Array.isArray(raw)) {
        filterValue = raw; // multiselect array
      } else {
        filterValue = isExclude ? raw.slice(1).trim().toLowerCase() : String(raw).trim().toLowerCase();
      }
      const itemValue = item[key];

      return this.checkItemValue(itemValue, filterValue, isExclude);
    });
    return isAnd ? results.every(Boolean) : results.some(Boolean);
  }

  private checkItemValue(itemValue: any, filterValue: any, isExclude: boolean): boolean {
    if (Array.isArray(filterValue) && filterValue.length>0) {
      const match = filterValue.includes(itemValue);
      return isExclude ? !match : match;
    }
    if (filterValue === 'null') return isExclude ? itemValue !== null : itemValue === null;
    if (filterValue === 'undefined') return isExclude ? itemValue !== undefined : itemValue === undefined;
    if (filterValue === '""') return itemValue === '';
    if (Array.isArray(filterValue) && filterValue.length==0) return true;
    if (!Number.isNaN(Number(filterValue)) && typeof itemValue === 'number') {
      const numericFilter = Number(filterValue);
      return isExclude ? itemValue !== numericFilter : itemValue === numericFilter;
    }

    if (typeof itemValue === 'string') {
      const match = this.normalizeText(itemValue)
        .includes(this.normalizeText(filterValue));
      return isExclude ? !match : match;
    }

    // fallback
    return isExclude ? itemValue != filterValue : itemValue == filterValue;
  }

  private  normalizeText(val: string): string {
    return val
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

}


@Pipe({ name: 'globalSearch' })
export class GlobalSearchPipe implements PipeTransform {
  transform(items: any[], search: string): any[] {
    if (!items || !search) return items;

    const s = this.normalizeText(search);

    return items.filter(item =>
      this.normalizeText(item.patient_full_name || '').includes(s) ||
      this.normalizeText(item.vehicle_license_plate || '').includes(s) ||
      this.normalizeText(item.vehicle_vehicle_no || '').includes(s) ||
      this.normalizeText(item.case_no || '').toLowerCase().includes(s) ||
      this.normalizeText(item.dot_dot_name || '').includes(s) ||
      this.normalizeText(item.case_code_code || '').includes(s)
    );
  }

  private  normalizeText(val: string): string {
    return val
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }
}


/*@Pipe({ name: 'filterQ' })
export class FilterQ implements PipeTransform {
  transform(items: any[], filter: Record<string, any>, isAnd: boolean): any[] {
    if (!items || !filter) return items;

    const keys = Object.keys(filter).filter(k => filter[k] !== undefined && filter[k] !== null && !(typeof filter[k] === 'string' && filter[k].trim() === ''));
    if (!keys.length) return items;

    return items.filter(item => this.checkAllKeys(item, keys, filter, isAnd));
  }

  private checkAllKeys(item: any, keys: string[], filter: Record<string, any>, isAnd: boolean): boolean {
    const results = keys.map(key => {
      const raw = filter[key];
      const isExclude = typeof raw === 'string' && raw.startsWith('!');
      const filterValue = isExclude ? raw.slice(1).trim().toLowerCase() : String(raw).trim().toLowerCase();
      const itemValue = item[key];
      return this.checkItemValue(itemValue, filterValue, isExclude);
    });
    return isAnd ? results.every(Boolean) : results.some(Boolean);
  }

  private checkItemValue(itemValue: any, filterValue: string, isExclude: boolean): boolean {
    if (filterValue === 'null') return isExclude ? itemValue !== null : itemValue === null;
    if (filterValue === 'undefined') return isExclude ? itemValue !== undefined : itemValue === undefined;
    if (filterValue === '""') return itemValue === '';

    if (!Number.isNaN(Number(filterValue)) && typeof itemValue === 'number') {
      const numericFilter = Number(filterValue);
      return isExclude ? itemValue !== numericFilter : itemValue === numericFilter;
    }

    if (typeof itemValue === 'string') {
      const match = new RegExp(filterValue, 'i').test(itemValue);
      return isExclude ? !match : match;
    }

    return isExclude ? itemValue != filterValue : itemValue == filterValue;
  }
}*/
